import React, { PureComponent, Fragment } from 'react'
import {
  Grid,
  Paper,
  Table,
  TableCell,
  TableBody,
  TableHead,
  TableRow,
  MenuItem,
  ListItem,
  Button,
  IconButton,
  Drawer,
  Tooltip,
} from '@material-ui/core'
import { FormatListBulleted, Info } from '@material-ui/icons'
import SearchIcon from '@material-ui/icons/Search'
import Typography from '@material-ui/core/Typography/Typography'
import EditActionComponent from '../common/EditActionComponent'
import _ from 'lodash'
import { EditableTextField, EditableSwitch, EditableSelect } from '../common/EditableComponents'
import {
  metrcEnvironmentOptions as environmentOptions,
  getCaStates,
  getUsStates,
} from '../../utils/constants'
import MetrcMergedNewItemContainer from './MetrcMergedNewItemContainer'
import { onChangeEditHOF } from '../../utils/common'
import {
  createMetrcLocation,
  getMetrcLocationTypes,
  getPackageLocationFlag,
  updateDefaultMetrcLocation,
} from '../../actions/thirdParty'
import { openErrorMessage, openSuccessMessage } from '../../actions/message'
import { getShopList } from '../../actions/shop'
import { getComplianceInventoryRoomsDisplayData } from '../../utils/compliance'
import { getComplianceInventoryRooms } from '../../actions/compliance'
import { CompliancePage } from '../MfeParcels/CompliancePage'
import { mfeConfigs } from '../../utils/mfe'

export default class MetrcMergedFacilities extends PureComponent {
  onChange = onChangeEditHOF(this.props.onChange)

  state = {
    creatingLocationMode: false,
    locationId: 0,
    newLocationName: null,
    newLocationTypeName: null,
    facAccountLicense: '',
    packageLocationFlag: false,
    editingLocationMode: false,
    complianceRoomOptions: [],
    shopId: this.props.shop.id,
    selectedFacility: null,
  }

  componentDidMount() {
    if (this.props.facilities === {}) {
      this.props.enableEdit()
    }
    this.props.retrieveFacilities()
    this.props.dispatch(getPackageLocationFlag()).then((res) => {
      if (res) {
        this.setState({ packageLocationFlag: res })
      }
    })
  }

  retrieveLocationTypes = () => {
    this.props.dispatch(getMetrcLocationTypes())
  }

  toggleCreateLocation = () => {
    const creating = this.state.creatingLocationMode
    if (!creating) {
      //pull metrc location types
      this.retrieveLocationTypes()
    }
    this.setState({
      creatingLocationMode: !creating,
    })
  }

  toggleEditLocation = () => {
    const { shops, shop } = this.props
    const editing = this.state.editingLocationMode
    let thisShop = _.find(shops, { id: shop.id }) || {}
    const { defaultMetrcLocation = {} } = thisShop
    if (!editing) {
      this.props.dispatch(getComplianceInventoryRooms()).then((res) =>
        this.setState({
          newLocationName: defaultMetrcLocation ? defaultMetrcLocation.Name : '',
          newLocationTypeName: defaultMetrcLocation ? defaultMetrcLocation.LocationTypeName : '',
          complianceRoomOptions: getComplianceInventoryRoomsDisplayData('METRC', res) || [],
        }),
      )
    } else {
      this.setState({
        newLocationName: '',
        newLocationTypeName: '',
      })
    }
    this.setState({
      editingLocationMode: !editing,
    })
  }

  cancelEditLocation = () => {
    this.setState({
      newLocationName: '',
      newLocationTypeName: '',
      editingLocationMode: false,
    })
  }

  cancelCreateLocation = () => {
    this.setState({ creatingLocationMode: false })
  }

  onChangeLocationType = (locationType) => (e) => {
    let target = e.target.value

    if (target && target != '') {
      this.setState({
        newLocationTypeName: target,
      })
    }
  }

  onChangeLocation = (location) => (e) => {
    let target = e.target.value || ''
    this.setState({
      newLocationName: target,
    })
  }

  onSubmitMetrcPackageLocation = () => {
    const { newLocationName, newLocationTypeName } = this.state

    let valid = true
    valid =
      newLocationName && newLocationName != '' && newLocationTypeName && newLocationTypeName != ''

    //submit
    if (valid === true) {
      let data = {
        Name: newLocationName,
        LocationTypeName: newLocationTypeName,
      }
      this.props.dispatch(createMetrcLocation(data)).then((res) => {
        this.setState({
          creatingLocationMode: false,
          newLocationName: '',
          newLocationTypeName: '',
        })
        this.props.dispatch(getShopList())
        this.props.dispatch(openSuccessMessage('Shop Metrc default package created'))
      })
    } else {
      this.props.dispatch(openErrorMessage('Please enter a valid location and location type name'))
    }
  }

  updateEditLocation = () => {
    const { locationId = 0 } = this.state
    let valid = true
    valid = locationId > 0
    if (valid) {
      let data = {
        Id: locationId,
      }
      this.props.dispatch(updateDefaultMetrcLocation(data)).then((res) => {
        console.log(res, 'Updated default metrc location.')
        this.cancelEditLocation()
        this.props.dispatch(getShopList())
        this.props.dispatch(openSuccessMessage('Shop Metrc default package updated'))
      })
    } else {
      this.props.dispatch(openErrorMessage('Please select a valid location'))
    }
  }

  ScrollDown = () => {
    var isRendered = !!document.getElementById('scroll-typography-title')
    if (isRendered) {
      document.getElementById('scroll-typography-title').scrollIntoView()
    }
  }

  render() {
    const {
      data,
      editMode,
      shops = [],
      facilitiesOptions = {},
      onChangeFacility,
      onAddNewFacility,
      checkApiKey,
      metrcLocationTypes,
      shop,
    } = this.props

    const {
      creatingLocationMode = false,
      newLocationTypeName,
      newLocationName,
      complianceRoomOptions,
      editingLocationMode = false,
    } = this.state

    const { facilities = [], locations = [] } = data

    const enabledLocationShopsId =
      locations.length !== 0 &&
      locations.filter((location) => location.enabled).map((location) => location.shopId)

    const editableFacilities =
      enabledLocationShopsId &&
      facilities.filter((facility) => !enabledLocationShopsId.includes(facility.shopId))
    const availableShops =
      locations &&
      shops &&
      facilities &&
      shops.filter(
        (shop) =>
          (!facilities.includes(facilities.find((facility) => facility.shopId === shop.id)) &&
            !locations.includes(
              locations.find((location) => location.shopId === shop.id), //No biotrack or metrc record
            )) ||
          (!facilities.includes(facilities.find((facility) => facility.shopId === shop.id)) &&
            locations.includes(
              locations.find(
                (location) => location.shopId === shop.id && location.enabled === false,
              ), //No biotrack and metrc disabled
            )),
      )

    const thisFacility = _.find(facilities, { shopId: shop.id }) || {}
    let thisShop = _.find(shops, { id: shop.id }) || {}
    const { defaultMetrcLocation = {} } = thisShop
    const allStates = [...getUsStates(), ...getCaStates()]

    return (
      <Fragment>
        <Grid container>
          <Grid className="unversalScroll" item xs={12} sm={12} md={12} lg={12}>
            <Paper className="paper-page">
              <div className="table-scroll">
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell colSpan={4}></TableCell>
                      <TableCell colSpan={3} style={{ textAlign: 'center' }} >Metrc API</TableCell>
                      <TableCell colSpan={5}></TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell>Shop Name</TableCell>
                      <TableCell>App Type</TableCell>
                      <TableCell>State Code</TableCell>
                      <TableCell>Environment</TableCell>
                      <TableCell>Admin API Key</TableCell>
                      <TableCell>Facility License</TableCell>
                      <TableCell>API Permission</TableCell>
                      <TableCell>Enabled</TableCell>
                      <TableCell>Enable Sync</TableCell>
                      <TableCell>Post Delivery Transaction</TableCell>
                      <TableCell>Enable Package Tracking Location</TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {editableFacilities &&
                      editableFacilities.map((facility, index) => {
                        const id = facility.id
                        const selectedShop = shops.find((shop) => facility.shopId === shop.id) || {}
                        const { facLicense = '', stateCode = '' } = facility
                        const facilityOptions = facilitiesOptions[stateCode] || []
                        const metrcFacilityType = (
                          _.find(facilityOptions, {
                            License: {
                              Number: facLicense,
                            },
                          }) || {}
                        ).FacilityType
                        const viewPermissionDisabled = !facility.userApiKey || !facility.facLicense

                        return (
                          <TableRow key={index}>
                            <TableCell>{selectedShop.name}</TableCell>
                            <TableCell>{selectedShop.appTarget}</TableCell>
                            <TableCell>
                              <EditableSelect
                                valueToRender={facility.stateCode || ''}
                                value={facility.stateCode || ''}
                                editMode={editMode}
                                onChange={onChangeFacility(id, 'stateCode')}
                              >
                                {allStates.map((option, index) => {
                                  return (
                                    <MenuItem key={index} value={option.value}>
                                      {option.value}
                                    </MenuItem>
                                  )
                                })}
                              </EditableSelect>
                            </TableCell>
                            <TableCell>
                              <EditableSelect
                                valueToRender={facility.environment}
                                editMode={editMode}
                                value={facility.environment}
                                onChange={onChangeFacility(id, 'environment')}
                              >
                                {environmentOptions.map((env) => {
                                  return <MenuItem value={env.value}>{env.label}</MenuItem>
                                })}
                              </EditableSelect>
                            </TableCell>

                            <TableCell>
                              <Grid container>
                                <Grid item sm={10}>
                                  <EditableTextField
                                    valueToRender={facility.userApiKey}
                                    editMode={editMode}
                                    value={facility.userApiKey}
                                    onChange={onChangeFacility(id, 'userApiKey')}
                                    type="text"
                                  />
                                </Grid>
                                <Grid item sm={2}>
                                  {editMode ? (
                                    <SearchIcon
                                      style={{
                                        cursor: 'pointer',
                                      }}
                                      onClick={checkApiKey(id)}
                                    />
                                  ) : null}
                                </Grid>
                              </Grid>
                            </TableCell>
                            <TableCell className="cell-wrap-word">
                              <Grid item sm={10}>
                                {stateCode ? (
                                  <EditableSelect
                                    sm={12}
                                    valueToRender={facLicense}
                                    value={facLicense}
                                    editMode={editMode}
                                    onChange={onChangeFacility(
                                      id,
                                      'facLicense',
                                      false,
                                      this.state.packageLocationFlag &&
                                        thisFacility.enablePackageLocationTracking,
                                    )}
                                  >
                                    {!stateCode ? (
                                      <MenuItem value={null}>Please select state code.</MenuItem>
                                    ) : null}
                                    {facilityOptions.map((option, index) => {
                                      return (
                                        <MenuItem key={index} value={option.License.Number} sm={10}>
                                          {option.License.Number} ({option.Name} |{' '}
                                          {option.License.LicenseType})
                                        </MenuItem>
                                      )
                                    })}
                                  </EditableSelect>
                                ) : (
                                  <span>Please select facility.</span>
                                )}
                              </Grid>
                            </TableCell>
                            <TableCell style={{ position: 'relative' }}>
                              <IconButton 
                                disabled={viewPermissionDisabled}
                                aria-label="View API permission"
                              >
                                <FormatListBulleted onClick={() => this.setState({ facility })} />
                              </IconButton>

                              {
                                viewPermissionDisabled &&
                                <Tooltip title='Select API Key and Facility License to view API permission'>
                                  <Info color='action' style={{ fontSize: 16, position: 'absolute', left: 52, bottom: 28 }} />
                                </Tooltip>
                              }
                            </TableCell>
                            <TableCell>
                              <EditableSwitch
                                valueToRender={facility.enabled ? 'Enabled' : 'Disabled'}
                                checked={facility.enabled}
                                editMode={editMode}
                                onChange={onChangeFacility(id, 'enabled', true)}
                              />
                            </TableCell>
                            <TableCell>
                              <EditableSwitch
                                valueToRender={facility.enableSync ? 'Enabled' : 'Disabled'}
                                checked={facility.enableSync}
                                editMode={editMode}
                                onChange={onChangeFacility(id, 'enableSync', true)}
                              />
                            </TableCell>
                            <TableCell>
                              <EditableSwitch
                                valueToRender={
                                  facility.enableDeliveryTransaction ? 'Enabled' : 'Disabled'
                                }
                                checked={facility.enableDeliveryTransaction}
                                editMode={editMode}
                                onChange={onChangeFacility(id, 'enableDeliveryTransaction', true)}
                              />
                            </TableCell>
                            <TableCell>
                              <EditableSwitch
                                valueToRender={
                                  facility.enablePackageLocationTracking ? 'Enabled' : 'Disabled'
                                }
                                checked={facility.enablePackageLocationTracking}
                                editMode={
                                  facility.shopId === shop.id &&
                                  metrcFacilityType &&
                                  metrcFacilityType.canUpdateLocationsOnPackages &&
                                  editMode
                                }
                                onChange={onChangeFacility(
                                  id,
                                  'enablePackageLocationTracking',
                                  true,
                                  this.state.packageLocationFlag &&
                                    thisFacility.enablePackageLocationTracking,
                                )}
                              />
                            </TableCell>
                            <TableCell>
                              {facility.enablePackageLocationTracking &&
                              this.state.packageLocationFlag &&
                              selectedShop.id == this.state.shopId ? (
                                <button
                                  className="primary-button padding-small"
                                  style={{ cursor: 'pointer' }}
                                  onClick={this.ScrollDown}
                                >
                                  EDIT/CREATE
                                </button>
                              ) : null}
                            </TableCell>
                          </TableRow>
                        )
                      })}

                    {
                      this.state.facility && 
                      <Drawer
                        open={!!this.state.facility}
                        onClose={() => {
                          this.setState({ facility: null })
                        }}
                        anchor='right'
                      >
                        <Grid style={{ margin: 16 }}>
                          <CompliancePage
                            merchantId={`blu-${this.state.facility.companyId}-${this.state.facility.shopId}`}
                            facility={this.state.facility}
                          />
                        </Grid>
                      </Drawer>
                    }
                  </TableBody>
                </Table>
                {this.state.packageLocationFlag && thisFacility.enablePackageLocationTracking && (
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Paper className="paper-page">
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Typography className="margin-left-small" variant="headline">
                          Metrc Packages Location
                        </Typography>
                        {editMode && (
                          <Typography
                            style={{ fontSize: '1em' }}
                            className="margin-left-small"
                            variant="headline"
                          >
                            Confirm your changes to edit this! <br />
                            WARNING: Editing the Metrc Facility license will clear the current
                            default Metrc Location.
                          </Typography>
                        )}
                      </Grid>
                      {!editMode && !creatingLocationMode && !editingLocationMode && (
                        <Grid style={{ marginLeft: '25px' }} item xs={12} sm={12} md={12} lg={12}>
                          <Button className="primary-button" onClick={this.toggleEditLocation}>
                            Edit
                          </Button>
                          <Button className="login-button" onClick={this.toggleCreateLocation}>
                            Create+
                          </Button>
                        </Grid>
                      )}
                      <Grid item xs={12} sm={12} md={12} lg={12}>
                        {!editMode && !creatingLocationMode ? (
                          <div>
                            <ListItem>
                              <Grid container>
                                <Grid className="labelField" item xs={6} sm={6} md={6} lg={6}>
                                  <Typography>Default Location</Typography>
                                </Grid>
                                <Grid className="editField" item xs={6} sm={6} md={6} lg={6}>
                                  <EditableSelect
                                    editMode={editingLocationMode}
                                    valueToRender={
                                      !editingLocationMode
                                        ? defaultMetrcLocation && defaultMetrcLocation.Name
                                        : newLocationName
                                    }
                                    value={
                                      !editingLocationMode
                                        ? defaultMetrcLocation && defaultMetrcLocation.Name
                                        : newLocationName
                                    }
                                    onChange={(e) => {
                                      let room = _.find(complianceRoomOptions, {
                                        name: e.target.value,
                                      })
                                      this.setState({
                                        locationId: room.id,
                                        newLocationName: room.name,
                                        newLocationTypeName: room.type,
                                      })
                                    }}
                                  >
                                    {complianceRoomOptions &&
                                      complianceRoomOptions.length &&
                                      complianceRoomOptions.map((location, index) => {
                                        return (
                                          <MenuItem value={location.name} key={index}>
                                            {location.name}
                                          </MenuItem>
                                        )
                                      })}
                                  </EditableSelect>
                                </Grid>
                              </Grid>
                            </ListItem>
                            <ListItem>
                              <Grid container>
                                <Grid className="labelField" item xs={6} sm={6} md={6} lg={6}>
                                  <Typography>Location Type</Typography>
                                </Grid>
                                <Grid className="editField" item xs={4} sm={4} md={4} lg={4}>
                                  <EditableTextField
                                    valueToRender={
                                      (defaultMetrcLocation &&
                                        defaultMetrcLocation.LocationTypeName) ||
                                      newLocationTypeName
                                    }
                                    value={
                                      (defaultMetrcLocation &&
                                        defaultMetrcLocation.LocationTypeName) ||
                                      newLocationTypeName
                                    }
                                    onChange={this.onChange('metrcPackageDefaultLocation')}
                                    placeholder="Enter metrc package default location name"
                                  />
                                </Grid>
                                {editingLocationMode && (
                                  <Grid item xs={2} sm={2} md={2} lg={2}>
                                    <Button
                                      className="primary-button"
                                      onClick={this.updateEditLocation}
                                    >
                                      Save
                                    </Button>
                                    <Button
                                      className="login-button"
                                      onClick={this.toggleEditLocation}
                                    >
                                      Cancel
                                    </Button>
                                  </Grid>
                                )}
                              </Grid>
                            </ListItem>
                          </div>
                        ) : null}
                        {!editMode && creatingLocationMode && !editingLocationMode ? (
                          <div>
                            <ListItem>
                              <Grid container>
                                <Grid className="labelField" item xs={6} sm={6} md={6} lg={6}>
                                  <Typography>Default Location</Typography>
                                </Grid>
                                <Grid className="editField" item xs={6} sm={6} md={6} lg={6}>
                                  <EditableTextField
                                    valueToRender={newLocationName || ''}
                                    value={newLocationName || ''}
                                    //onChange={this.onChange('metrcPackageDefaultLocation')}
                                    onChange={this.onChangeLocation()}
                                    placeholder="Enter metrc package default location name"
                                    editMode={creatingLocationMode}
                                  />
                                </Grid>
                              </Grid>
                            </ListItem>
                            <ListItem>
                              <Grid container>
                                <Grid className="labelField" item xs={6} sm={6} md={6} lg={6}>
                                  <Typography>Default Location Type</Typography>
                                </Grid>
                                <Grid className="editField" item xs={6} sm={6} md={6} lg={6}>
                                  <EditableSelect
                                    value={newLocationTypeName}
                                    onChange={this.onChangeLocationType()}
                                    valueToRender={newLocationTypeName}
                                    editMode={creatingLocationMode}
                                    displayEmpty={true}
                                  >
                                    <MenuItem value="">Select Metrc location type</MenuItem>
                                    {metrcLocationTypes &&
                                      metrcLocationTypes.length &&
                                      metrcLocationTypes.map((type, index) => {
                                        return (
                                          <MenuItem value={type.Name} key={index}>
                                            {type.Name}
                                          </MenuItem>
                                        )
                                      })}
                                  </EditableSelect>
                                </Grid>
                              </Grid>
                            </ListItem>
                            <ListItem>
                              <Grid container>
                                <Grid className="editField" item xs={12} sm={6} md={6} lg={6}>
                                  {creatingLocationMode ? (
                                    <EditActionComponent
                                      onSave={this.onSubmitMetrcPackageLocation}
                                      onCancel={this.toggleCreateLocation}
                                      onEdit={this.toggleCreateLocation}
                                      editMode={creatingLocationMode}
                                      editTitle={'Create'}
                                    />
                                  ) : null}
                                </Grid>
                              </Grid>
                            </ListItem>
                          </div>
                        ) : null}
                      </Grid>
                    </Paper>
                  </Grid>
                )}
              </div>
            </Paper>
          </Grid>
        </Grid>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Compliance/MetrcMergedFacilites.js